// Imports de imágenes locales para sectors
import officeImg from '@/assets/images/sectors/office.jpg';
import buildingsImg from '@/assets/images/sectors/buildings.jpg';
import hotelsImg from '@/assets/images/sectors/hotels.jpg';
import restaurantsImg from '@/assets/images/sectors/restaurants.jpg';
import industrialKitchensImg from '@/assets/images/sectors/industrial-kitchens.jpg';
import schoolsImg from '@/assets/images/sectors/schools.jpg';
import institutionsImg from '@/assets/images/sectors/institutions.jpg';
import shoppingCentersImg from '@/assets/images/sectors/shopping-centers.jpg';
import housingImg from '@/assets/images/sectors/housing.jpg';
import publicAreasImg from '@/assets/images/sectors/public-areas.jpg';

// Servicios - Actualizados (eliminados: hoteles, restaurantes, escuelas, cocinas industriales)
export const services = [
  ['Limpieza de oficinas', 'Espacios ordenados y agradables para colaboradores y visitantes.'],
  ['Limpieza de edificios', 'Cobertura integral para inmuebles corporativos y comerciales.'],
  ['Fraccionamientos', 'Cuidado profesional de accesos y espacios compartidos.'],
  ['Áreas públicas', 'Atención organizada para superficies de uso colectivo.'],
  ['Instituciones gubernamentales', 'Procesos responsables para instalaciones públicas.'],
  ['Centros comerciales', 'Cobertura continua para espacios de alta afluencia.'],
  ['Servicios especiales', 'Soluciones definidas según cada instalación y necesidad.'],
];

// Pasos para staff
export const staffSteps = [
  'Reclutamiento',
  'Selección',
  'Evaluación',
  'Contratación',
  'Capacitación',
  'Asignación del personal',
];

// Pasos para clientes
export const clientSteps = [
  ['Propuesta de servicio', 'Envío de presentación general y propuesta inicial.'],
  ['Visita al cliente', 'Conocemos las instalaciones y entendemos cada necesidad.'],
  [
    'Cotización personalizada',
    'Definimos personal, rutinas, materiales y registros, adaptando la propuesta al presupuesto.',
  ],
  ['Contrato e inicio', 'Formalizamos la colaboración y comenzamos a prestar el servicio.'],
  [
    'Supervisión',
    'Verificamos la ejecución y solicitamos retroalimentación con la periodicidad requerida.',
  ],
  [
    'Atención continua',
    'Atendemos observaciones y nuevas necesidades cuando el cliente lo requiera.',
  ],
];

// Sectores - Actualizados
export const sectors = [
  ['Oficinas', officeImg],
  ['Edificios', buildingsImg],
  ['Hoteles', hotelsImg],
  ['Restaurantes', restaurantsImg],
  ['Cocinas industriales', industrialKitchensImg],
  ['Escuelas', schoolsImg],
  ['Instituciones', institutionsImg],
  ['Centros comerciales', shoppingCentersImg],
  ['Fraccionamientos', housingImg],
  ['Áreas públicas', publicAreasImg],
];